import { Trans, useTranslation } from "react-i18next";
import { Box, CopyButton, FlexColBox } from "../../common/components";

import {
  OrderDetail,
  PreOrderPaymentOptions,
  AddressTypeEnum,
} from "../../types";
import { AddressBox } from "../AddressBox";
import { OrderSummary } from "../OrderSummary";
import { createStyles, palette } from "../../styles/theme";
import { Typography } from "@mui/material";
import { formatAddressForTools } from "../../utils/userAddress.utils";
import OrdersExpandSectionItems from "../Orders/OrdersExpandSectionItems";

const styles = createStyles({
  orderReview: {
    width: "100%",
    maxWidth: "100%",
    flex: 1,
    padding: "16px 16px",
    borderBottom: `1px solid ${palette.grey.midGrey}`,
    gap: "16px",
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
  },
});

interface Props {
  orderDetail: OrderDetail;
}

const AdminOrderExpandSection = ({ orderDetail }: Props) => {
  const { t } = useTranslation();

  return (
    <FlexColBox>
      <FlexColBox sx={styles.orderReview}>
        <FlexColBox gap={"4px"}>
          <Typography variant="textRegularBold">
            {t("order.billing")}
          </Typography>
          <AddressBox
            address={orderDetail.billingAddress}
            addressType={AddressTypeEnum.BILLING}
          />
        </FlexColBox>
        <FlexColBox gap={"4px"}>
          <Box display={"flex"} alignItems={"center"} gap={"4px"}>
            <Typography variant="textRegularBold">
              {t("order.delivery")}
            </Typography>
            <CopyButton
              value={formatAddressForTools(orderDetail.shippingAddress)}
            />
          </Box>
          <AddressBox
            address={orderDetail.shippingAddress}
            addressType={AddressTypeEnum.SHIPPING}
          />
        </FlexColBox>
        <FlexColBox gap={"16px"}>
          <FlexColBox gap={"4px"}>
            <Typography variant="textRegularBold">
              {t("order.payment_option")}
            </Typography>
            <Typography variant="textRegular">
              <Trans
                i18nKey={`checkout.payment_options.${orderDetail.paymentOption ?? PreOrderPaymentOptions.NOT_SET}`}
                components={{
                  1: (
                    <Typography variant="textXs" color={palette.grey.primary} />
                  ),
                }}
              />
            </Typography>
          </FlexColBox>
          {orderDetail.notes && (
            <FlexColBox gap={"4px"}>
              <Typography variant="textRegularBold">
                {t("order.note")}
              </Typography>
              <Typography variant="textRegular">{orderDetail.notes}</Typography>
            </FlexColBox>
          )}
        </FlexColBox>
        <FlexColBox gap={"4px"}>
          <Typography variant="textRegularBold">
            {t("order.order_summary")}
          </Typography>
          <Box
            sx={{
              "*": {
                color: `${palette.grey.nearBlack} !important`,
                borderColor: `${palette.grey.darkerGrey} !important`,
              },
            }}
          >
            <OrderSummary orderDetail={orderDetail} />
          </Box>
        </FlexColBox>
      </FlexColBox>

      <OrdersExpandSectionItems orderDetail={orderDetail} />
    </FlexColBox>
  );
};

export default AdminOrderExpandSection;
